export const keyCustomCode = 'custom-modal-plugin__code';
export const typeCustomCode = 'custom-modal';
export const commandNameCustomCode = 'custom-modal:open-modal';